import { api } from 'boot/axios'

export function getDocument(id) {
  return api.get(`/documents/${id}`)
}

export function removeDocument(id) {
  return api.delete(`/documents/${id}`)
}

export function updateDocument(document) {
  return api.put(`/documents/${document.id}`, document)
}

export function acquitDocument(id, data) {
  return api.post(`/documents/${id}/acquit`, data)
}

export function uploadDocument(url, data) {
  return api.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function updateFile(file) {
  return api.put(`/files/${file.id}`, file)
}

export function checkFile(fileSrc) {
  return api.head(fileSrc)
}

/**
 * @typedef {{ name?: ?string, description?: ?string, publicFile?: boolean }} PrepareFileUploadRequest
 */
/**
 * @param {PrepareFileUploadRequest} data
 * @returns {Promise<import('axios').AxiosResponse<any>>}
 */
export function prepareFile(data) {
  const body = {
    name: data.name,
    description: data.description,
    public: data.publicFile || false
  }
  return api.post('/files/prepare', body, {
    maxRedirects: 0
  })
}

export function updateExternalFile(externalFile) {
  return api.put(`/external_files/${externalFile.id}`, externalFile)
}

export function listDocumentPatientFile(patientFileId, pagination, filters = {}, sort = null) {
  let params = {
    page: pagination.page,
    pageSize: pagination.pageSize,
    ...filters || {}
  }

  if (sort) {
    params.sort = sort
  }

  return api.get(`/patient_files/${patientFileId}/documents`, { params: params })
}

export function addIdentityDocumentFromFile(patientId, identityDocumentTypeId, fileId, document) {
  return api.post(`/persons/${patientId}/identity_documents/${identityDocumentTypeId}/from_file/${fileId}`, { ...document })
}

/**
 * @param {{
 *   page: !int,
 *   pageSize: !int,
 *   startDate: ?string,
 *   endDate: ?string,
 *   orderBy: ?string,
 *   orderDirection: ?string,
 *   searchQuery: ?string,
 *   establishment: ?string,
 *   patientFile: ?string,
 *   services: ?string[],
 *   protocol: ?string,
 *   acknowledgementStatus: ?string[],
 *   professionalAttentionRequired: ?boolean,
 *   fileType: ?string,
 *   provider: ?string,
 *   status: ?string,
 *   asCaregiver: ?boolean,
 *   onlyVisibleByProfessionals: ?boolean,
 *   withPrescriptions: ?boolean,
 *   prescriptionStatuses: ?string[],
 * }} params
 */
export function listDocuments(params) {
  return api.get('/documents', { params })
}
